import { useState, useEffect } from "react";
import { FaPaperPlane } from "react-icons/fa";
import { sendProductToTelegram } from "../services/telegramService";

export default function ChatButton({ brandProducts, telegramUserId }) {
  const [notification, setNotification] = useState(null);

  // ✅ Проверяем, доступен ли Telegram WebApp
  useEffect(() => {
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.ready(); // Гарантируем, что API инициализировано
    }
  }, []);

  const handleSend = async () => {
    console.log("📢 Перед отправкой в Telegram:", telegramUserId);
    try {
      await sendProductToTelegram(brandProducts, telegramUserId);
      setNotification({ type: "success", message: "✅ Предложения отправлены в чат!" });

      // ⏳ Показываем уведомление перед закрытием
      setTimeout(() => {
        setNotification(null);

        if (window.Telegram && window.Telegram.WebApp) {
          console.log("📌 Закрытие миниаппа...");
          window.Telegram.WebApp.close(); // ✅ Закрываем миниапп
        } else {
          console.error("❌ Ошибка: Telegram WebApp API недоступен.");
        }
      }, 2000);

    } catch (error) {
      setNotification({ type: "error", message: "❌ Ошибка при отправке." });
    }
  };

  return (
    <div className="fixed bottom-0 w-full bg-gradient-to-t from-[#1B2433] to-[#2D415A] shadow-2xl p-3 flex justify-center">
      {notification && (
        <div
          className={`absolute top-[-50px] px-6 py-3 rounded-lg shadow-lg text-white text-lg font-semibold transition-all duration-500 ease-in-out
          ${notification.type === "success" ? "bg-green-500" : "bg-red-500"}`}
        >
          {notification.message}
        </div>
      )}

      <button
        className="w-[95%] max-w-md bg-gradient-to-r from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-white py-3 rounded-lg shadow-lg text-lg font-semibold flex items-center justify-center transition duration-200"
        onClick={handleSend}
      >
        <FaPaperPlane size={20} className="mr-2" /> Отправить в чат
      </button>
    </div>
  );
}
